/**
 * Checks if the passed element currently has visible (keyboard) focus.
 *
 * Uses the `:focus-visible` pseudo class: browsers apply it for keyboard
 * focus but usually not for mouse clicks.
 *
 * The `fallback` is what the answer becomes when the selector is not supported
 * (legacy browsers, jsdom). It defaults to `true` because the original caller
 * only draws a focus indicator, where showing one too often is harmless. A
 * caller that ROUTES the focus based on the answer must pass `false` instead,
 * so an unsupported selector keeps the pointer behavior rather than silently
 * treating every mouse click as keyboard input.
 *
 * @param {Element} element - element to check
 * @param {boolean} fallback - answer to use when `:focus-visible` is unsupported
 *
 * @returns {boolean} true if the focus should be treated as keyboard focus
 */
export function isFocusVisible(element: Element, fallback: boolean = true): boolean {
  try {
    return element.matches(':focus-visible');
  } catch (error) {
    return fallback;
  }
}
